"use client";

import { alpha } from "@mui/material/styles";
import { gray, green } from "../theme-primitives";

export const surfacesCustomizations = {
  MuiAccordion: {
    defaultProps: {
      elevation: 0,
      disableGutters: true,
    },
    styleOverrides: {
      root: ({ theme }) => ({
        padding: 4,
        overflow: "clip",
        backgroundColor: (theme.vars || theme).palette.background.default,
        border: "1px solid",
        borderColor: (theme.vars || theme).palette.divider,
        borderRadius: 8,
        "&:not(:last-of-type)": {
          marginBottom: 16,
        },
      }),
    },
  },
  MuiAccordionSummary: {
    styleOverrides: {
      root: ({ theme }) => ({
        border: "none",
        borderRadius: 8,
        "&:hover": { backgroundColor: gray[50] },
        "&:focus-visible": { backgroundColor: "transparent" },
        ...theme.applyStyles("dark", {
          "&:hover": { backgroundColor: gray[800] },
        }),
      }),
    },
  },
  MuiAccordionDetails: {
    styleOverrides: {
      root: { mb: 20, border: "none" },
    },
  },
  MuiPaper: {
    defaultProps: {
      elevation: 0,
    },
  },
  MuiCard: {
    styleOverrides: {
      root: ({ theme }) => {
        return {
          padding: 24,
          gap: 10,
          display: "flex",
          flexDirection: "column",
          transition: "all 100ms ease",
          backgroundColor: "#fff",
          boxShadow: "0px 10px 15px 0px #0000001A, 0px 4px 6px 0px #0000001A",
          borderRadius: "0.5rem",
          ...theme.applyStyles("dark", {
            backgroundColor: gray[800],
          }),
          variants: [
            {
              props: {
                elevation: 1,
              },
              style: {
                border: "1px solid #E5E7EB",
                boxShadow: "0px 1px 2px 0px #0000000D",
                background: "hsl(0, 0%, 100%)",
                ...theme.applyStyles("dark", {
                  background: alpha(gray[900], 0.4),
                }),
              },
            },
            {
              props: {
                color: "green",
              },
              style: {
                border: "1px solid #E5E7EB",
                boxShadow: "0px 1px 2px 0px #0000000D",
                color: "#fff",
                background: green[400],
                ...theme.applyStyles("dark", {
                  background: alpha(gray[900], 0.4),
                }),
              },
            },
            {
              props: {
                variant: "outlined",
              },
              style: {
                border: `1px solid ${(theme.vars || theme).palette.divider}`,
                boxShadow: "none",
                background: "hsl(0, 0%, 100%)",
                ...theme.applyStyles("dark", {
                  background: alpha(gray[900], 0.4),
                }),
              },
            },
            {
              props: {
                variant: "large",
              },
              style: {
                border: "none",
                boxShadow: "none",
                borderRadius: 12,
                background: "hsl(0, 0%, 100%)",
                ...theme.applyStyles("dark", {
                  background: alpha(gray[900], 0.4),
                }),
              },
            },
            {
              props: {
                variant: "grey",
              },
              style: {
                border: "1px solid #E5E7EB",
                background: "#F9FAFB",
                boxShadow: "none",
                borderRadius: 8,
                ...theme.applyStyles("dark", {
                  background: alpha(gray[900], 0.4),
                }),
              },
            },
          ],
        };
      },
    },
  },
  MuiContainer: {
    styleOverrides: {
      root: {
        padding: 0,
        variants: [
          {
            props: {
              variant: "dull",
            },
            style: {
              background: gray[100],
            },
          },
          {
            props: {
              variant: "green",
            },
            style: {
              background: green[500],
            },
          },
          {
            props: {
              variant: "light-green",
            },
            style: {
              background: "#ECFDF5",
            },
          },
        ],
      },
    },
  },
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: 0,
        "&:last-child": { paddingBottom: 0 },
      },
    },
  },
  MuiCardHeader: {
    styleOverrides: {
      root: {
        padding: 0,
      },
    },
  },
  MuiCardActions: {
    styleOverrides: {
      root: {
        padding: 0,
      },
    },
  },
};
